<template>
  <v-card flat>
    <v-card-subtitle class="py-0 text-overline">
      Manage your profile
    </v-card-subtitle>
    <v-card-text>
      <!-- FIXME: non mi convince come è stato implementato qui -->
      <v-row>
        <v-col cols="12" md="4">
          <v-list-item two-line>
            <v-list-item-avatar size="88" class="mt-0">
              <sl-avatar v-if="user.id" :user="user" :size="77" />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-form ref="firstNameForm" v-model="firstNameFormIsValid">
                <sl-text-field
                  :rules="nameRules"
                  v-model="user.firstName"
                  id="firstName"
                  label="First name"
                  name="firstName"
                  type="text"
                  required
                  @focus="onFirstNameEditing"
                  @update="firstNameSubmit"
                  dense
                />
              </v-form>
              <v-form ref="lastNameForm" v-model="lastNameFormIsValid">
                <div class="w-100" />
                <sl-text-field
                  :rules="nameRules"
                  v-model="user.lastName"
                  id="lastName"
                  label="Last name"
                  name="lastName"
                  type="text"
                  required
                  dense
                  @focus="onLastNameEditing"
                  @update="lastNameSubmit"
                />
              </v-form>
            </v-list-item-content>
          </v-list-item>
          Your email address: <span class="text-subtitle-2">{{ user.email }}</span
          ><br />
          Subscription plan: <span class="text-subtitle-2">{{ userPlan }}</span>
        </v-col>

        <v-col>
          <v-divider />
          <v-card flat>
            <v-card-title class="text-subtitle-2">
              Change your password
            </v-card-title>
            <v-card-text>
              <password-change />
            </v-card-text>
          </v-card>
          <v-card flat>
            <v-card-title class="pb-0 text-subtitle-2">
              Update privacy preferences
            </v-card-title>
            <v-card-text>
              <v-checkbox
                v-model="user.mailinglistAccepted"
                label="I agree to be updated with the lastest Sharylist news"
                @change="mailinglistAcceptedSubmit"
              />
            </v-card-text>
          </v-card>
          <v-divider />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import User from '@/models/User'

import SlAvatar from '@/components/SlAvatar'
import SlTextField from '@/components/SlTextField'
// import SlCheckbox from '@/components/SlCheckbox'
import PasswordChange from '@/components/PasswordChange'

export default {
  components: {
    SlAvatar,
    SlTextField,
    // SlCheckbox,
    PasswordChange,
  },

  data() {
    return {
      //
      user: {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        mailinglistAccepted: false,
      },
      nameRules: [v => !!v || 'Required', v => (v && v.length <= 32) || 'Max 32 characters'],
      firstNameBackup: '',
      firstNameFormIsValid: true,
      lastNameBackup: '',
      lastNameFormIsValid: true,
    }
  },

  computed: {
    userPlan() {
      var planShown = ''
      switch (this.user.plan) {
        case 'unlimited':
          planShown = 'Unlimited'
          break
        case 'Strenne2020':
          planShown = 'Holidays2020'
          break
        case 'EarlySupporters':
          planShown = 'Early Supporter'
          break
        case null:
          planShown = 'Free'
          break
        default:
          planShown = 'Custom'
      }
      return planShown
    },
    ...mapState(['userLogged']),
  },

  created() {
    this.queries = [
      User.find({
        get: '{id, firstName, lastName, email, mailinglistAccepted, plan }',
        by: { id: this.userLogged.id },
        onChange: data => {
          this.user = data
        },
        onError: error => {
          Logger.error('ERROR in loading data:', error)
          this.toastSet({
            message: 'Error in loading data',
            color: 'error',
          })
        },
      }),
    ]
  },

  mounted() {
    //
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    onFirstNameEditing() {
      this.firstNameBackup = this.user.firstName
    },
    async firstNameSubmit() {
      if (this.user.firstName !== this.firstNameBackup) {
        if (this.firstNameFormIsValid) {
          try {
            await User.save(this.user)
            this.firstNameBackup = this.user.firstName
            Logger.debug('firstNameSubmit', this.user.firstName)
            this.toastSet({
              message: 'First name successfully changed',
              color: 'success',
            })
          } catch (e) {
            this.user.firstName = this.firstNameBackup
            Logger.error(e)
            this.toastSet({
              message: 'Error in updating first name',
              color: 'error',
            })
          }
        } else {
          this.user.firstName = this.firstNameBackup
          this.toastSet({
            message: 'Error in name validation, restoring previous name',
            color: 'error',
          })
        }
      }
    },
    onLastNameEditing() {
      this.lastNameBackup = this.user.lastName
    },
    async lastNameSubmit() {
      if (this.user.lastName !== this.lastNameBackup) {
        if (this.lastNameFormIsValid) {
          try {
            await User.save(this.user)
            this.lastNameBackup = this.user.lastName
            Logger.debug('lastNameSubmit', this.user.lastName)
            this.toastSet({
              message: 'Last name successfully changed',
              color: 'success',
            })
          } catch (e) {
            this.user.lastName = this.lastNameBackup
            Logger.error(e)
            this.toastSet({
              message: 'Error in updating last name',
              color: 'error',
            })
          }
        } else {
          this.user.lastName = this.lastNameBackup
          this.toastSet({
            message: 'Error in name validation, restoring previous name',
            color: 'error',
          })
        }
      }
    },
    async mailinglistAcceptedSubmit() {
      try {
        Logger.debug('saving mailinglistAccepted', this.user.mailinglistAccepted)
        await User.save(this.user)
        Logger.debug('mailinglistAcceptedSubmit', this.user.mailinglistAccepted)
      } catch (e) {
        Logger.error(e)
        this.toastSet({
          message: 'Error in updating privacy preferences',
          color: 'error',
        })
      }
    },
    ...mapMutations(['toastSet']),
  },
}
</script>
